export const clickEvent = (eventName) => {
    typeof window?.gtag !== 'undefined' && window.gtag('event', eventName);
};
